import { generateName } from "@common/Common";
import { CapexAccountReadModel } from "@Quest/Financials/Capex/Domain/readmodels";

export class CapexItemEditorViewModel
{
    opened: boolean = false;
    modalTitle: string | null = null;
    confirmButtonLabel: string | null = null;

    id: string | null = null;
    name: string | null = null;
    accountId: string | null = null;
    cost: number | null = null;
    usefulLifeInYears: number | null = null;
    acquisitionMonthIndex: number | null = null;
    salvageValue: number | null = null;

    currencyLabel: string | null = null;
    accounts: CapexAccountReadModel[] = [];

    

    showCreator(currencyLabel: string, accounts: CapexAccountReadModel[])
    {
        this.id = null;
        this.name = generateName('Capex');
        this.accountId = null;
        this.cost = null;
        this.usefulLifeInYears = 7;
        this.acquisitionMonthIndex = 0;
        this.salvageValue = 0;

        this.currencyLabel = currencyLabel;
        this.accounts = accounts;

        this.modalTitle = "Create capex";
        this.confirmButtonLabel = "Create";

        this.opened = true;
    }

    showEditor(id: string, name: string, accountId: string, cost: number, usefulLifeInYears: number, acquisitionMonthIndex: number, salvageValue: number,
        currencyLabel: string, accounts: CapexAccountReadModel[])
    {
        this.id = id;
        this.name = name;
        this.accountId = accountId;
        this.cost = cost;
        this.usefulLifeInYears = usefulLifeInYears;
        this.acquisitionMonthIndex = acquisitionMonthIndex;
        this.salvageValue = salvageValue;

        this.currencyLabel = currencyLabel;
        this.accounts = accounts;

        this.modalTitle = "Edit capex";
        this.confirmButtonLabel = "Update";

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.id = null;
        this.name = null
        this.accountId = null;
        this.cost = null;
        this.usefulLifeInYears = null
        this.acquisitionMonthIndex = null
        this.salvageValue = null;

        this.currencyLabel = null;
        this.accounts = [];
    }
}

export class CapexItemEditorFormSubmitEventPayload
{
    id: string | null;
    name: string;
    accountId: string;
    cost: number;
    usefulLifeInYears: number;
    acquisitionMonthIndex: number;
    salvageValue: number;

    constructor(id: string | null, name: string, accountId: string, cost: number, usefulLifeInYears: number, acquisitionMonthIndex: number, salvageValue: number)
    {
        this.id = id;
        this.name = name;
        this.accountId = accountId;
        this.cost = cost;
        this.usefulLifeInYears = usefulLifeInYears;
        this.acquisitionMonthIndex = acquisitionMonthIndex;
        this.salvageValue = salvageValue;
    }
}